import Company from './company'
import Doctor from './doctor'
import Hospital from './hospital'
import { APIClient } from '@/infrastructure/network/Algolia/APIClient'

export default class AlgoliaGateway {
  apiClient: APIClient
  Company: Company
  Doctor: Doctor
  Hospital: Hospital

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
    this.Company = new Company(apiClient)
    this.Doctor = new Doctor(apiClient)
    this.Hospital = new Hospital(apiClient)
  }
}
